import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableRow, TableHead } from '@mui/material';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';
import { Typography } from '@totalsoft/rocket-ui';

const GenericEntityFlowEditStatesHead = () => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCellWithWidth w={26}>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.State')}</Typography>
        </TableCellWithWidth>
        <TableCellWithWidth w={15} align='center'>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.Color')}</Typography>
        </TableCellWithWidth>
        <TableCellWithWidth w={15} align='center'>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.InitialState')}</Typography>
        </TableCellWithWidth>
        <TableCellWithWidth w={15} align='center'>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.ActivatesEntity')}</Typography>
        </TableCellWithWidth>
        <TableCellWithWidth w={15} align='center'>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.EditableYN')}</Typography>
        </TableCellWithWidth>
        <TableCellWithWidth w={15} align='center'>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.DeletePermitted')}</Typography>
        </TableCellWithWidth>
        <TableCellWithWidth w={15}>
          <Typography fontWeight='bold'>{t('GenericEntityFlow.Actions')}</Typography>
        </TableCellWithWidth>
      </TableRow>
    </TableHead>
  );
};

export default GenericEntityFlowEditStatesHead;
